import GeneralInformationDashboardModal from "./general-information-dashboard-modal.component";

export default GeneralInformationDashboardModal;
